import { Component, OnInit, ViewChild } from '@angular/core';
import { OperationResult } from '../../../models/server-result/operation-result';
import { HttpErrorResponse } from '@angular/common/http';
import { ReportingApiService } from '../../../server-api/reporting-api/reporting-api.service';
import { ServerApiService } from '../../../server-api/server-api.service';
import { ToasterService } from '../../../shared-components/custom-toaster/toaster.service';
import { AppContextService } from '../../../services/app-context.service';
import { DateLocalePipe } from '../../../services/date-locale.pipe';
import { User } from '../../../models/User/user';
import { ConfirmingContract } from '../../../models/contracts/confirming/confirming-contract';
import { ConfirmingContractsSearchCriteria } from '../../../models/contracts/confirming/confirming-contracts-search-criteria';
import { ConfirmingConnectionsSearchCriteria } from '../../../models/contracts/confirming/confirming-connections-search-criteria';
import { ConfirmingConnection } from '../../../models/contracts/confirming/confirming-connection';
import { OperationError } from '../../../models/server-result/operation-error';
import { FactoringContractsSearchCriteria } from '../../../models/contracts/factoring/factoring-contracts-search-criteria';
import { FactoringConnectionsSearchCriteria } from '../../../models/contracts/factoring/factoring-connections-search-criteria';
import { FactoringConnection } from '../../../models/contracts/factoring/factoring-connection';
import { forkJoin, Observable } from 'rxjs';
import { FactoringContract } from '../../../models/contracts/factoring/factoring-contract';
import { UtilitiesService } from '../../../services/utils/utilities.service';
import dayjs from '../../../services/dayjs-setup';
import { CurrencyCode } from '../../../models/enums/currency-code';
import { Router } from '@angular/router';
import { FileIntegrationStateService } from '../../../services/file-integration-state.service';
import { SearchFilesIntegrationComponent } from '../../files-integration/search-files-integration/search-files-integration.component';
import { FileStatus } from '../../../models/enums/FileIntegration/integration-file-status';
import { TranslateService } from '../../../services/translate/translate.service';
import { CommissionsApiService } from '../../../server-api/commissions-api/commissions-api.service';
import { CommissionsSearchCriteria, CommissionsSumValues } from '../../../server-api/commissions-api/commissions-api.models';
import { CurrencyViewModel, DASHBOARD_TAB_CONFIRMING, DASHBOARD_TAB_FACTORING } from '../dashboard.types';
import { DashboardHelperService } from '../dashboard-helper.service';
import { DashboardFactoringTabComponent } from '../dashboard-factoring-tab/dashboard-factoring-tab.component';
import { CustomTabItem, TabAction } from '../../../shared-components/custom-tabs/custom-tabs.component';
import { SegmentedControlOption } from '../../../shared-components/custom-segmented-control/custom-segmented-control.component';

@Component({
	selector: 'app-dashboard-operator',
	templateUrl: './dashboard-operator.component.html',
	styleUrls: ['../private-home.component.scss', './dashboard-operator.component.scss'],
	standalone: false,
})
export class DashboardOperatorComponent implements OnInit {
	public loggedUser: User | null = new User();
	public requestErrors: OperationError[] = [];

	public confirmingApprovedRequestFunds: number = 0;
	public confirmingNotPaidDocuments: number = 0;
	public confirmingBuyersWithActiveContractsCompaniesCount: number = 0;
	public confirmingSuppliersWithActiveConnectionsCompaniesCount: number = 0;
	public confirmingContractedAmount: number = 0;
	public confirmingContractsAvailableAmount: number = 0;

	public confirmingAverageMonthFundingRequestDays: number = 0;
	public confirmingCurrentFundingRequestsAmount: number = 0;
	public confirmingMonthlyAutomaticPayments: number = 0;
	public saphetyComission: number = 0;
	public confirmingSuppliersActiveConnections: number = 0;
	public confirmingContractsAvailableAmountRatio: number = 0;
	public confirmingPendingApprovalDocumentsAmount: number = 0;

	public CurrentMonth: Date;
	private month: number = new Date().getMonth() + 1;
	private year: number = new Date().getFullYear();

	public totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections: number = 0;
	public totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts: number = 0;
	public totalActiveConnections: number = 0;

	public selectedCurrency: string;
	public orderedCurrencies: CurrencyViewModel[] = [];
	public currencyOptions: SegmentedControlOption[] = [];

	public confirmingTabVisible: boolean = false;
	public factoringTabVisible: boolean = false;
	public activeTabId: string = DASHBOARD_TAB_CONFIRMING;
	public tabs: CustomTabItem[] = [];
	public tabActions: TabAction[] = [];

	protected DASHBOARD_TAB_CONFIRMING = DASHBOARD_TAB_CONFIRMING;
	protected DASHBOARD_TAB_FACTORING = DASHBOARD_TAB_FACTORING;

	protected CurrencyCode = CurrencyCode;
	protected FileStatus = FileStatus;

	public loadingConfirmingApprovedRequestFunds: boolean = false;
	public loadingConfirmingCurrentFundingRequestsAmount: boolean = false;
	public loadingConfirmingAverageMonthFundingRequestDays: boolean = false;
	public loadingConfirmingMonthlyAutomaticPayments: boolean = false;
	public loadingConfirmingNotPaidDocuments: boolean = false;
	public loadingConfirmingContractedAmount: boolean = false;
	public loadingConfirmingContractsAvailableAmount: boolean = false;
	public loadingConfirmingBuyersWithActiveContractsCompaniesCount: boolean = false;
	public loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount: boolean = false;
	public loadingConfirmingSuppliersActiveConnections: boolean = false;
	public loadingConfirmingPendingApprovalDocumentsAmount: boolean = false;

	public loadingSaphetyComission: boolean = false;
	public loadingTotalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections: boolean = false;
	public loadingTotalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts: boolean = false;
	public loadingTotalActiveConnections: boolean = false;

	public canNavigateToSovosCommissions: boolean = false;

	@ViewChild(DashboardFactoringTabComponent) private factoringTab: DashboardFactoringTabComponent | undefined;

	constructor(
		private reportingApiService: ReportingApiService,
		private commissionsApiService: CommissionsApiService,
		private serverApiService: ServerApiService,
		private toasterService: ToasterService,
		private utilitiesService: UtilitiesService,
		private appContext: AppContextService,
		private dateLocale: DateLocalePipe,
		private router: Router,
		private fileIntegrationStateService: FileIntegrationStateService,
		private translateService: TranslateService,
		private dashboardHelper: DashboardHelperService
	) {}

	ngOnInit() {
		this.appContext.getLoggedUserAsync().subscribe((userResult) => {
			this.loggedUser = userResult.Data;

			this.CurrentMonth = this.dateLocale.transform(new Date(), 'MM/yyyy');

			this.confirmingTabVisible = true;
			this.factoringTabVisible = true;
			this.tabs = this.dashboardHelper.createTabs(this.confirmingTabVisible, this.factoringTabVisible);
			this.tabActions = [this.dashboardHelper.createRefreshAction(() => this.refreshAllData())];

			this.canNavigateToSovosCommissions = !!this.loggedUser && (this.loggedUser.IsSystemAdmin || this.loggedUser.IsBackOfficeOperator);

			this.refreshAllData();
		});
	}

	public refreshAllData(): void {
		this.getSaphetyComission();
		this.getTotalCompaniesCount();
		this.loadConfirmingCards();
		this.factoringTab?.refresh();
	}

	private getConfirmingSuppliersActiveConnections(currency: string): void {
		this.dashboardHelper.loadMetric(
			this.reportingApiService.getConfirmingSuppliersActiveConnections(currency),
			(loading) => (this.loadingConfirmingSuppliersActiveConnections = loading),
			(value) => (this.confirmingSuppliersActiveConnections = value),
			'[DashboardOperatorComponent] Invalid result from getConfirmingSuppliersActiveConnections()'
		);
	}

	private getSaphetyComission(): void {
		this.loadingSaphetyComission = true;
		var date = new Date();
		var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

		const criteria = new CommissionsSearchCriteria();
		criteria.OrderBy = 'CreatedOn';
		criteria.PageNumber = 1;

		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = <CommissionsSearchCriteria>{
			CommissionDueDateEnd: dayjs.utc().year(lastDay.getFullYear()).month(lastDay.getMonth()).date(lastDay.getDate()).toDate(),
			CommissionDueDateStart: dayjs.utc().year(date.getFullYear()).month(date.getMonth()).date(1).toDate(),
		};

		this.dashboardHelper.loadMetric(
			this.commissionsApiService.getCommissionsSumValues(criteria.RestrictionCriteria),
			(loading) => (this.loadingSaphetyComission = loading),
			(value) => this.processValidgetCommissionsSumValues(value),
			'[DashboardOperatorComponent] Invalid result from getCommissionsSumValues()'
		);
	}

	private getConfirmingMonthlyAutomaticPayments(currency: string): void {
		this.dashboardHelper.loadMetric(
			this.reportingApiService.getConfirmingMonthlyAutomaticPayments(this.month, this.year, currency),
			(loading) => (this.loadingConfirmingMonthlyAutomaticPayments = loading),
			(value) => (this.confirmingMonthlyAutomaticPayments = value),
			'[DashboardOperatorComponent] Invalid result from getConfirmingMonthlyAutomaticPayments()'
		);
	}

	private getConfirmingAverageMonthFundingRequestDays(currency: string): void {
		this.dashboardHelper.loadMetric(
			this.reportingApiService.getConfirmingAverageMonthFundingRequestDays(this.month, this.year, currency),
			(loading) => (this.loadingConfirmingAverageMonthFundingRequestDays = loading),
			(value) => (this.confirmingAverageMonthFundingRequestDays = value),
			'[DashboardOperatorComponent] Invalid result from getConfirmingAverageMonthFundingRequestDays()'
		);
	}

	private getConfirmingCurrentFundingRequestsAmount(currency: string): void {
		this.dashboardHelper.loadMetric(
			this.reportingApiService.getConfirmingCurrentFundingRequestsAmount(currency),
			(loading) => (this.loadingConfirmingCurrentFundingRequestsAmount = loading),
			(value) => (this.confirmingCurrentFundingRequestsAmount = value),
			'[DashboardOperatorComponent] Invalid result from getConfirmingCurrentFundingRequestsAmount()'
		);
	}

	private getNotPaidDocumentsSum(currency: string): void {
		this.dashboardHelper.loadMetric(
			this.reportingApiService.getNotPaidDocumentsSum(currency),
			(loading) => (this.loadingConfirmingNotPaidDocuments = loading),
			(value) => (this.confirmingNotPaidDocuments = value),
			'[DashboardOperatorComponent] Invalid result from getNotPaidDocumentsSum()'
		);
	}

	private getConfirmingApprovedRequestFunds(currency: string) {
		const fundingRequestDocumentStates = ['Approved'];

		this.dashboardHelper.loadMetric(
			this.reportingApiService.getConfirmingFundingRequestsTotalAdvancedAmount(fundingRequestDocumentStates, currency),
			(loading) => (this.loadingConfirmingApprovedRequestFunds = loading),
			(value) => (this.confirmingApprovedRequestFunds = value),
			'[DashboardOperatorComponent] Invalid result from getConfirmingFundingRequestsTotalAdvancedAmount',
			'[DashboardOperatorComponent] HttpError result from getConfirmingFundingRequestsTotalAdvancedAmount'
		);
	}

	private getPendingApprovalDocumentsAmount(currency: string) {
		this.dashboardHelper.loadMetric(
			this.reportingApiService.getPendingApprovalDocumentsAmount(currency),
			(loading) => (this.loadingConfirmingPendingApprovalDocumentsAmount = loading),
			(value) => (this.confirmingPendingApprovalDocumentsAmount = value.Confirming),
			'[DashboardOperatorComponent] Invalid result from getPendingApprovalDocumentsAmount',
			'[DashboardOperatorComponent] HttpError result from getPendingApprovalDocumentsAmount'
		);
	}

	private refreshConfirmingContractDataForCurrency(currency: string) {
		this.loadingConfirmingContractedAmount = true;
		this.loadingConfirmingContractsAvailableAmount = true;
		this.loadingConfirmingBuyersWithActiveContractsCompaniesCount = true;

		this.confirmingContractedAmount = 0;
		this.confirmingContractsAvailableAmount = 0;
		this.confirmingContractsAvailableAmountRatio = 0;
		this.confirmingBuyersWithActiveContractsCompaniesCount = 0;

		const criteria: ConfirmingContractsSearchCriteria = new ConfirmingContractsSearchCriteria();
		criteria.OrderBy = 'EndDate';
		criteria.PageNumber = 1;
		criteria.OrderDescending = true;
		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = new ConfirmingContractsSearchCriteria();
		criteria.RestrictionCriteria.ContractStateList = ['Active'];
		criteria.RestrictionCriteria.Currency = currency;

		this.serverApiService.searchConfirmingContracts(criteria).subscribe((getConfirmingContracts) => {
			this.loadingConfirmingContractedAmount = false;
			this.loadingConfirmingContractsAvailableAmount = false;
			this.loadingConfirmingBuyersWithActiveContractsCompaniesCount = false;
			if (!getConfirmingContracts.IsValid) {
				if (getConfirmingContracts.Errors && getConfirmingContracts.Errors.length > 0) {
					this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
						errors: getConfirmingContracts.Errors,
						autoClose: false,
					});
				}
			} else {
				if (!!getConfirmingContracts.Data && getConfirmingContracts.Data.length > 0) {
					getConfirmingContracts.Data.forEach((contract) => {
						this.confirmingContractedAmount += contract.ContractedAmount;
						this.confirmingContractsAvailableAmount += contract.AvailableAmount;
						this.confirmingContractsAvailableAmountRatio = this.dashboardHelper.contractsAvailableRatio(
							this.confirmingContractsAvailableAmount,
							this.confirmingContractedAmount
						);
					});

					this.confirmingBuyersWithActiveContractsCompaniesCount = this.dashboardHelper.distinctCount(
						getConfirmingContracts.Data.map((c) => c.Buyer.Id)
					);
				}
			}
		});
	}

	private getConfirmingActiveContracts() {
		let currencies: CurrencyViewModel[] = [];
		let retrievedConfirmingContracts: ConfirmingContract[] = [];

		this.confirmingContractedAmount = 0;
		this.confirmingContractsAvailableAmount = 0;
		this.confirmingContractsAvailableAmountRatio = 0;
		this.confirmingBuyersWithActiveContractsCompaniesCount = 0;

		const criteria: ConfirmingContractsSearchCriteria = new ConfirmingContractsSearchCriteria();
		criteria.OrderBy = 'EndDate';
		criteria.PageNumber = 1;
		criteria.OrderDescending = true;
		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = new ConfirmingContractsSearchCriteria();
		criteria.RestrictionCriteria.ContractStateList = ['Active'];

		this.serverApiService.searchConfirmingContracts(criteria).subscribe({
			next: (getConfirmingContracts: OperationResult<ConfirmingContract[]>) => {
				if (getConfirmingContracts.IsValid) {
					if (!!getConfirmingContracts.Data && getConfirmingContracts.Data.length > 0) {
						getConfirmingContracts.Data.forEach((contract) => {
							retrievedConfirmingContracts.push(contract);
							this.dashboardHelper.addCurrencyIfMissing(currencies, contract.Currency);
						});

						this.orderedCurrencies = this.dashboardHelper.sortCurrencies(currencies);
						this.currencyOptions = this.dashboardHelper.toCurrencyOptions(this.orderedCurrencies);

						if (!!this.orderedCurrencies && this.orderedCurrencies.length > 0) {
							let initialCurrencytoProcess = this.orderedCurrencies[0].Currency;

							let contractsOfInitialCurrency: ConfirmingContract[] = retrievedConfirmingContracts.filter(
								(c) => c.Currency == initialCurrencytoProcess
							);

							contractsOfInitialCurrency.forEach((contract) => {
								this.confirmingContractedAmount += contract.ContractedAmount;
								this.confirmingContractsAvailableAmount += contract.AvailableAmount;
								this.confirmingContractsAvailableAmountRatio = this.dashboardHelper.contractsAvailableRatio(
									this.confirmingContractsAvailableAmount,
									this.confirmingContractedAmount
								);
							});

							this.confirmingBuyersWithActiveContractsCompaniesCount = this.dashboardHelper.distinctCount(
								contractsOfInitialCurrency.map((c) => c.Buyer.Id)
							);

							this.selectedCurrency = initialCurrencytoProcess;

							this.getConfirmingActiveConnections(this.selectedCurrency);
							this.getConfirmingSuppliersActiveConnections(this.selectedCurrency);
							this.getNotPaidDocumentsSum(this.selectedCurrency);
							this.getConfirmingApprovedRequestFunds(this.selectedCurrency);
							this.getConfirmingAverageMonthFundingRequestDays(this.selectedCurrency);
							this.getConfirmingCurrentFundingRequestsAmount(this.selectedCurrency);
							this.getConfirmingMonthlyAutomaticPayments(this.selectedCurrency);
							this.getPendingApprovalDocumentsAmount(this.selectedCurrency);
						}
					}
				} else {
					this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
						errors: getConfirmingContracts.Errors,
						autoClose: false,
					});
				}
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				console.error('error: ' + httpErrorResponse.message);
				this.toasterService.showErrorFromHttpResponse(httpErrorResponse);
			},
		});
	}

	private getConfirmingActiveConnections(currency: string) {
		this.loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount = true;
		const criteria: ConfirmingConnectionsSearchCriteria = new ConfirmingConnectionsSearchCriteria();
		criteria.PageNumber = 1;
		criteria.RowsPerPage = 2147483647;
		criteria.RestrictionCriteria = new ConfirmingConnectionsSearchCriteria();
		criteria.RestrictionCriteria.ConnectionStateList = ['Active'];
		criteria.RestrictionCriteria.ContractStateList = ['Active'];
		criteria.RestrictionCriteria.Currency = currency;

		this.serverApiService.searchConfirmingConnections(criteria).subscribe({
			next: (operationResult: OperationResult<ConfirmingConnection[]>) => {
				this.loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount = false;
				if (operationResult.IsValid) {
					if (!!operationResult.Data) {
						if (operationResult.Data.length > 0)
							this.confirmingSuppliersWithActiveConnectionsCompaniesCount = this.dashboardHelper.distinctCount(
								operationResult.Data.map((c) => c.Supplier.Id)
							);
						else this.confirmingSuppliersWithActiveConnectionsCompaniesCount = 0;
					}
				} else {
					this.toasterService.showError(this.translateService.translate('VALIDATION_FAILED', 'list-errorCodes'), {
						errors: operationResult.Errors,
						autoClose: false,
					});
				}
			},
			error: (httpErrorResponse: HttpErrorResponse) => {
				this.loadingConfirmingSuppliersWithActiveConnectionsCompaniesCount = false;
				console.error('error: ' + httpErrorResponse.message);
				this.toasterService.showErrorFromHttpResponse(httpErrorResponse);
			},
		});
	}

	public clickedCurrency(currency: string): void {
		this.selectedCurrency = currency;

		this.refreshConfirmingContractDataForCurrency(this.selectedCurrency);
		this.getConfirmingActiveConnections(this.selectedCurrency);
		this.getConfirmingSuppliersActiveConnections(this.selectedCurrency);
		this.getNotPaidDocumentsSum(this.selectedCurrency);
		this.getConfirmingApprovedRequestFunds(this.selectedCurrency);
		this.getConfirmingAverageMonthFundingRequestDays(this.selectedCurrency);
		this.getConfirmingCurrentFundingRequestsAmount(this.selectedCurrency);
		this.getConfirmingMonthlyAutomaticPayments(this.selectedCurrency);
		this.getPendingApprovalDocumentsAmount(this.selectedCurrency);
	}

	private getTotalCompaniesCount(): void {
		this.loadingTotalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections = true;
		this.loadingTotalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts = true;
		this.loadingTotalActiveConnections = true;
		const confirmingContractsSearchCriteria: ConfirmingContractsSearchCriteria = new ConfirmingContractsSearchCriteria();
		confirmingContractsSearchCriteria.PageNumber = 1;
		confirmingContractsSearchCriteria.OrderDescending = true;
		confirmingContractsSearchCriteria.RowsPerPage = 2147483647;
		confirmingContractsSearchCriteria.RestrictionCriteria = new ConfirmingContractsSearchCriteria();
		confirmingContractsSearchCriteria.RestrictionCriteria.ContractStateList = ['Active'];

		const confirmingConnectionsSearchCriteria: ConfirmingConnectionsSearchCriteria = new ConfirmingConnectionsSearchCriteria();
		confirmingConnectionsSearchCriteria.PageNumber = 1;
		confirmingConnectionsSearchCriteria.RowsPerPage = 2147483647;
		confirmingConnectionsSearchCriteria.RestrictionCriteria = new ConfirmingConnectionsSearchCriteria();
		confirmingConnectionsSearchCriteria.RestrictionCriteria.ConnectionStateList = ['Active'];
		confirmingConnectionsSearchCriteria.RestrictionCriteria.ContractStateList = ['Active'];

		const factoringContractsSearchCriteria: FactoringContractsSearchCriteria = new FactoringContractsSearchCriteria();
		factoringContractsSearchCriteria.PageNumber = 1;
		factoringContractsSearchCriteria.OrderDescending = true;
		factoringContractsSearchCriteria.RowsPerPage = 2147483647;
		factoringContractsSearchCriteria.RestrictionCriteria = new FactoringContractsSearchCriteria();
		factoringContractsSearchCriteria.RestrictionCriteria.ContractStateList = ['Active'];

		const factoringConnectionsSearchCriteria: FactoringConnectionsSearchCriteria = new FactoringConnectionsSearchCriteria();
		factoringConnectionsSearchCriteria.PageNumber = 1;
		factoringConnectionsSearchCriteria.RowsPerPage = 2147483647;
		factoringConnectionsSearchCriteria.RestrictionCriteria = new FactoringConnectionsSearchCriteria();
		factoringConnectionsSearchCriteria.RestrictionCriteria.ConnectionStateList = ['Active'];
		factoringConnectionsSearchCriteria.RestrictionCriteria.ContractStateList = ['Active'];

		let servicesCallsToMake: Array<
			Observable<OperationResult<ConfirmingConnection[] | ConfirmingContract[] | FactoringContract[] | FactoringConnection[]>>
		> = [];

		servicesCallsToMake.push(this.serverApiService.searchConfirmingContracts(confirmingContractsSearchCriteria));
		servicesCallsToMake.push(this.serverApiService.searchConfirmingConnections(confirmingConnectionsSearchCriteria));
		servicesCallsToMake.push(this.serverApiService.searchFactoringContracts(factoringContractsSearchCriteria));
		servicesCallsToMake.push(this.serverApiService.searchFactoringConnections(factoringConnectionsSearchCriteria));

		const getAllRequests = forkJoin(servicesCallsToMake);

		getAllRequests.subscribe((opResults) => {
			this.loadingTotalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections = false;
			this.loadingTotalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts = false;
			this.loadingTotalActiveConnections = false;
			let confirmingContractsSearchResult = opResults[0] as OperationResult<ConfirmingContract[]>;
			let confirmingConnectionsSearchResult = opResults[1] as OperationResult<ConfirmingConnection[]>;
			let factoringContractsSearchResult = opResults[2] as OperationResult<FactoringContract[]>;
			let factoringConnectionsSearchResult = opResults[3] as OperationResult<FactoringConnection[]>;

			if (
				confirmingContractsSearchResult.IsValid &&
				confirmingConnectionsSearchResult.IsValid &&
				factoringContractsSearchResult.IsValid &&
				factoringConnectionsSearchResult.IsValid
			) {
				let confirmingBuyersIds = confirmingContractsSearchResult.Data?.map((c) => c.Buyer.Id).filter(this.utilitiesService.notEmpty);

				let confirmingSuppliersIds = confirmingConnectionsSearchResult.Data?.map((c) => c.Supplier.Id).filter(
					this.utilitiesService.notEmpty
				);

				let factoringSuppliersIds = factoringContractsSearchResult.Data?.map((c) => c.Supplier.Id).filter(this.utilitiesService.notEmpty);

				let factoringBuyersIds = factoringConnectionsSearchResult.Data?.map((c) => c.Buyer.Id).filter(this.utilitiesService.notEmpty);

				this.totalBuyersWithActiveConfirmingContractsAndActiveFactoringConnections =
					this.utilitiesService.getDistinctValues(confirmingBuyersIds.concat(factoringBuyersIds))?.length || 0;
				this.totalSuppliersWithActiveConfirmingConnectionsAndActiveFactoringContracts =
					this.utilitiesService.getDistinctValues(confirmingSuppliersIds.concat(factoringSuppliersIds))?.length || 0;

				this.totalActiveConnections = confirmingConnectionsSearchResult.Data.length + factoringConnectionsSearchResult.Data.length;
			}
		});
	}

	private loadConfirmingCards(): void {
		this.getConfirmingActiveContracts();
	}

	public clickedConfirmingTab(): void {
		this.activeTabId = DASHBOARD_TAB_CONFIRMING;
	}

	public clickedFactoringTab(): void {
		this.activeTabId = DASHBOARD_TAB_FACTORING;
		this.selectedCurrency = CurrencyCode.Euro;
	}

	public onTabChange(tabId: string): void {
		if (tabId === DASHBOARD_TAB_CONFIRMING) this.clickedConfirmingTab();
		else if (tabId === DASHBOARD_TAB_FACTORING) this.clickedFactoringTab();
	}

	private processValidgetCommissionsSumValues(commissionsSumValues: CommissionsSumValues[]): void {
		let eurCommissionsSumValues = commissionsSumValues.filter((c) => c.ConversionCurrency == CurrencyCode.Euro);

		const reducer = (accumulator: number, currentValue: number): number => accumulator + currentValue;
		this.saphetyComission = eurCommissionsSumValues?.map((v) => v.Sum)?.reduce(reducer, 0) ?? 0;
	}

	public navigateToSovosCommissions(): void {
		if (this.canNavigateToSovosCommissions) {
			this.router.navigateByUrl('/private/administration/commissions');
		}
	}

	public navigateToFilesIntegration(key: string): void {
		SearchFilesIntegrationComponent.navigateWithFileStatus(this.router, this.fileIntegrationStateService, key);
	}
}
